import React, { useEffect } from 'react';
import { useNotification } from '../../utils/NotificationContext';
import { FaCheck, FaHeart, FaPlus } from 'react-icons/fa';
import './NotificationBanner.scss';

const NotificationBanner = () => {
  const { notification, hideNotification } = useNotification();

  useEffect(() => {
    if (notification) {
      // Optional: Add sound effect or haptic feedback here
    }
  }, [notification]);

  if (!notification) return null;

  const getIcon = () => {
    if (notification.message.includes('ulubionych')) {
      return <FaHeart className="notification_icon" />;
    }
    if (notification.message.includes('listy')) {
      return <FaPlus className="notification_icon" />;
    }
    return <FaCheck className="notification_icon" />;
  };

  return (
    <div className="notification_banner_overlay" onClick={hideNotification}>
      <div className={`notification_banner ${notification.type}`}>
        <div className="notification_glow"></div>
        <div className="notification_content">
          <div className="notification_icon_container">
            {getIcon()}
          </div>
          <p className="notification_message">{notification.message}</p>
        </div>
        <div className="notification_progress"></div>
      </div>
    </div>
  );
};

export default NotificationBanner;
